var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 7,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  fillRule: "evenodd",
  d: "M1.423.244A.833.833 0 1 0 .244 1.423l5 5a.833.833 0 0 0 1.179 0l5-5A.833.833 0 0 0 10.244.244l-4.41 4.41z",
  clipRule: "evenodd"
})));
export default SvgDropdown;